// The scan confirmation chirp — legacy's default "barcode" two-tone, synthesised with Web Audio so it needs no
// asset and no plugin. Best-effort: an AudioContext that will not start (a locked engine) stays silent; the haptic
// and the toast still confirm the tap. Legacy's selectable sound presets are not carried — their choice lived in
// localStorage, which this app does not use.
//
// WebKit only lets an AudioContext start inside a USER GESTURE, and every chirp fires from a native `tagFound`
// callback, which is not one. So the context is created and unlocked by `unlockScanAudio()` on the tap that starts
// scan mode (legacy played a silent buffer on the picker tap for exactly this); created lazily inside the first
// scan instead, it stays suspended and scan mode is silent for the whole session.
type AudioCtor = typeof AudioContext;

let ctx: AudioContext | null = null;

function context(): AudioContext | null {
  const w = window as unknown as { AudioContext?: AudioCtor; webkitAudioContext?: AudioCtor };
  const Ctor = w.AudioContext ?? w.webkitAudioContext;
  if (!Ctor) return null;
  ctx ??= new Ctor();
  return ctx;
}

/** Create + resume the context and play one silent sample. Call SYNCHRONOUSLY from a tap handler. */
export function unlockScanAudio(): void {
  try {
    const c = context();
    if (!c) return;
    void c.resume?.();
    const src = c.createBufferSource();
    src.buffer = c.createBuffer(1, 1, 22050);
    src.connect(c.destination);
    src.start(0);
  } catch {
    /* silent — the haptic + toast still confirm */
  }
}

export function playScanChirp(): void {
  try {
    const c = context();
    if (!c) return;
    void c.resume?.();
    const t0 = c.currentTime;
    for (const [freq, at] of [[1760, 0], [2349, 0.07]] as const) {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "square";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t0 + at);
      gain.gain.exponentialRampToValueAtTime(0.12, t0 + at + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + at + 0.06);
      osc.connect(gain).connect(c.destination);
      osc.start(t0 + at);
      osc.stop(t0 + at + 0.07);
    }
  } catch {
    /* silent — the haptic + toast still confirm */
  }
}
